<script>
    export default {
        props: {
            model: Array,
        },
        data() {
            return {
                daysOfWeek: null,
                startHours: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
                endHours: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"],
                minutes: ["00", "15", "30", "45"]
            }
        },
        created(){
            this.daysOfWeek = this.$tm('lang.main.days_of_week');
        },
        methods: {
            initModel(){

                this.model.push({
                    days: [0,1,2,3,4],
                    time: ["10","00","18","00"]
                })

            },
            isDayCheked(item, day){
                return item.days.includes(day);
            },
            toggle(item, day){
                let index = item.days.indexOf(day);
                if(index === -1){

                    this.model.forEach(el => {
                        el.days.forEach(eld => {
                            let index = el.days.indexOf(day);
                            if(index !== -1){
                                el.days.splice(index, 1);
                            }
                        })
                    });

                    item.days.push(day);
                }else{
                    item.days.splice(index, 1);
                }
            },
            addPeriod(){
                let leftDays = [], fullDays = [];
                this.model.forEach(el => {
                    el.days.forEach(eld => {
                        fullDays.push(eld)
                    })
                });

                [0, 1, 2, 3, 4, 5, 6].forEach(d => {
                    if(fullDays.indexOf(d) === -1){
                        leftDays.push(d);
                    }
                });

                this.model.push({
                    days: leftDays,
                    time: ["10","00","18","00"]
                })

            }
        },
        mounted() {
            if(this.model.length === 0){
                this.initModel();
            }

        },
        computed: {
            isAddPeriod(){
                if(this.model.length === 0){
                    return true;
                }

                let fullDays = [];

                this.model.forEach(el => {
                    el.days.forEach(eld => {
                        fullDays.push(eld)
                    })
                });

                return !(fullDays.length === 7);
            }
        },


    }
</script>
<template>
    <div class="work-time">
        <div v-for="(m, pindex) in model" class="flex flex-column gap-3 sm:flex-row">
            <div>
                <a
                    v-for="(day, index) in daysOfWeek"
                    href="#"
                   :class="[isDayCheked(m, index) ? 'greenbutton' : 'graybutton']"
                   @click.prevent="toggle(m, index, pindex)"
                   >
                    {{day}}
                </a>
            </div>
            <div>
                <i class="fa fa-clock-o" aria-hidden="true" :class="{disabled: m.days.length === 0}"></i>

                <select v-model="m.time[0]" :disabled="m.days.length === 0">
                    <option v-for="startHour in startHours" v-bind:value="startHour">{{ startHour }}</option>
                </select>
                <span>:</span>
                <select v-model="m.time[1]" :disabled="m.days.length === 0">
                    <option v-for="minute in minutes" v-bind:value="minute">{{ minute }}</option>
                </select>
                <span>&nbsp;—&nbsp;</span>
                <select v-model="m.time[2]" :disabled="m.days.length === 0">
                    <option v-for="endHour in endHours" v-bind:value="endHour">{{ endHour }}</option>
                </select>
                <span>:</span>
                <select v-model="m.time[3]" :disabled="m.days.length === 0">
                    <option v-for="minute in minutes" v-bind:value="minute">{{ minute }}</option>
                </select>

                <i class="fa fa-times" aria-hidden="true" @click.prevent="model.splice(pindex, 1)" v-if="pindex !== 0"></i>
                <i class="fa fa-plus" aria-hidden="true" v-if="isAddPeriod && (model.length === pindex + 1)" @click.prevent="addPeriod"></i>
            </div>
        </div>
    </div>
</template>

<style scoped>
    a.graybutton, a.greenbutton  {text-decoration: none; padding: 0px 10px; font-size: 10px; margin-right: 2px; line-height: 28px;}
    .fa-clock-o {padding-left: 15px;padding-right: 5px;}
    .fa-plus {cursor: pointer}
    .fa-times, .fa-plus {padding-left: 10px;}
    select{font-weight: 300; border: 1px solid #d0d3d8; padding: 4px 5px; width: inherit; display: inline;}
    select:disabled{background-color: #d0d3d8; opacity: 0.7;}
    .disabled{opacity: 0.5;}
</style>
